import axiosInstance from './axiosInstance';

export const login = async (account, password) => {
  const response = await axiosInstance.post('/auth/login', {
    account,
    password,
  });
  // The refresh_token will be automatically set as a cookie by the browser
  // We only need to return the access token and other data
  return response.data;
};

export const sendEmailVerificationForSignup = async (email) => {
  const response = await axiosInstance.post('/auth/signup/verification/email', {
    email,
  });
  return response.data;
};

export const sendEmailVerificationForReset = async (email) => {
  const response = await axiosInstance.post('/auth/password/verification/email', {
    email,
  });
  return response.data;
};

export const signup = async (email, password, verificationCode) => {
  const response = await axiosInstance.post('/auth/signup', {
    email,
    password,
    verificationCode,
  });
  return response.data;
};

export const refreshToken = async () => {
  const response = await axiosInstance.post('/auth/token/refresh');
  // The new refresh_token will be automatically set as a cookie by the browser
  // We only need to return the access token and other data
  return response.data;
};

export const changeEmail = async (email, verificationCode) => {
  const response = await axiosInstance.put('/users/me/email', {
    email,
    verificationCode,
  });
  return response.data;
};

export const changePassword = async (password) => {
  const response = await axiosInstance.put('/users/me/password', { password });
  return response.data;
};

export const resetPassword = async (account, password, verificationCode) => {
  const response = await axiosInstance.put('/auth/password', {
    account,
    password,
    verificationCode,
  });
  return response.data;
};

export const logout = async () => {
  try {
    await axiosInstance.post('/auth/logout');
  } catch (error) {
    console.error('Logout API error:', error);
    // Ignore errors as per requirements
  }
};

export const socialLogin = async (provider, tokenOrCode, callbackUrl = null) => {
  // If the provider is Google, the tokenOrCode is an ID Token
  if (provider.toLowerCase() === 'google') {
    const response = await axiosInstance.post('/auth/google/login', {
      idToken: tokenOrCode,
    });
    return response.data;
  } else if (provider.toLowerCase() === 'facebook') {
    // Real Facebook login implementation using authorization code
    const response = await axiosInstance.post('/auth/facebook/login', {
      code: tokenOrCode,
      redirectUri: callbackUrl || `${window.location.origin}/auth/facebook/callback`,
    });
    return response.data;
  } else if (provider.toLowerCase() === 'line') {
    const response = await axiosInstance.post('/auth/line/login', {
      code: tokenOrCode,
      redirectUri: callbackUrl || `${window.location.origin}/auth/line/callback`,
    });
    return response.data;
  }

  // For other providers, tokenOrCode is an Authorization Code (existing mock logic)
  console.log(`Mock API: Social login with ${provider}, authCode: ${tokenOrCode}`);
  await new Promise(resolve => setTimeout(resolve, 1000));

  if (tokenOrCode) {
    return { accessToken: `mock_social_access_token_for_${provider}` };
  } else {
    const error = new Error('Mock API: Authorization code is missing or invalid.');
    error.response = { data: { message: 'Authorization code is missing or invalid.' }, status: 400 };
    throw error;
  }
};